export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    advertiser: {
      id: {
        value: null,
        operator: 'in',
      },
    },
    country: {
      id: {
        value: null,
        operator: 'in',
      },
    },
    status: {
      value: null,
      operator: 'in',
    },
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
    viewMode: 'viewing',
  },
})
